import { render, staticRenderFns } from "./echarts-base.vue?vue&type=template&id=6c2a4478&scoped=true&"
import script from "./echarts-base.vue?vue&type=script&lang=js&"
export * from "./echarts-base.vue?vue&type=script&lang=js&"
import style0 from "./echarts-base.vue?vue&type=style&index=0&id=6c2a4478&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2a4478",
  null
  
)

export default component.exports